export default __webpack_public_path__ + "static/media/abra_caixa.7272caad.jpeg";